import { HIDE_NAVBAR, SHOW_NAVBAR } from "../actions/showNavAction";

export default function showNav(state = false, action) {
    switch (action.type) {
        case SHOW_NAVBAR:
            return true
        case HIDE_NAVBAR:
            return false
        default:
           return state;
    }
}